import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .Select {\n    width: 80px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Tue Dec 04 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { StructPropBuilder, PricingPermissions, PromoPermissions, Utils } from '@logio/common-be-fe';
import { inject } from 'mobx-react';
import * as React from 'react';
import { Col, Row } from 'react-flexbox-grid';
import createFilterOptions from 'react-select-fast-filter-options';
import styled from 'styled-components';
import { StoreName } from '../../../../shared/stores/StoreName';
import Button, { ButtonColor } from '../../../controls/Button';
import Field from '../../../forms/Field';
import { SelectIconAdapter } from '../../../forms/Field/Adapters';
import Form from '../../../forms/Form/Form';
import translate from '../../../i18n/translate';
import Modal from '../../../info/Modal';
import Icon, { IconColor, IconType } from '../../../media/Icon';
export var animalIcons = [IconType.animalDonkey, IconType.animalBeaver, IconType.animalFish, IconType.animalHedgehog, IconType.animalHen, IconType.animalPig, IconType.animalSheep, IconType.animalSquirrel, IconType.animalCat, IconType.animalDog, IconType.animalUnicorn, IconType.animalSloth, IconType.animalSkunk, IconType.animalRabbit, IconType.animalMongoose, IconType.animalKangaroo, IconType.animalHippopotamus, IconType.animalCamel, IconType.animalBat];
var builder = new StructPropBuilder('GridSettings');
var descriptions = {
  name: builder.str('name'),
  shared: builder.bool('shared'),
  icon: builder.str('icon')
};

var GridSettingsModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridSettingsModal, _React$Component);

  function GridSettingsModal() {
    var _this;

    _classCallCheck(this, GridSettingsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsModal).apply(this, arguments));
    _this.options = animalIcons.map(function (icon) {
      return {
        label: React.createElement(Icon, {
          iconType: icon,
          iconHeight: 24,
          iconColor: IconColor.Secondary
        }),
        value: icon
      };
    });
    return _this;
  }

  _createClass(GridSettingsModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          hidden = _this$props.hidden,
          gridSetting = _this$props.gridSetting,
          profileStore = _this$props.profileStore,
          onClose = _this$props.onClose,
          onSubmit = _this$props.onSubmit,
          onDelete = _this$props.onDelete;
      var readOnly = profileStore.profile.id !== gridSetting.userId && gridSetting.userId !== Utils.VOID_ID;
      return React.createElement(StyledGridSettingsModal, null, React.createElement(Modal, {
        hidden: hidden,
        title: translate('Save filter as'),
        close: onClose,
        zIndex: 10001
      }, React.createElement(Form, {
        descriptions: descriptions,
        onSubmit: onSubmit,
        initialValues: gridSetting,
        className: "quickViewForm"
      }, React.createElement(Field, {
        name: "name",
        fieldReadOnly: readOnly
      }), React.createElement(Field, {
        name: "icon",
        component: function component(props) {
          return SelectIconAdapter('icon', {
            options: _this2.options,
            filterOptions: createFilterOptions(_this2.options)
          }, false, readOnly, false)(props);
        }
      }), React.createElement("div", {
        style: {
          marginLeft: '190px'
        }
      }, React.createElement(Field, {
        name: "shared",
        fieldReadOnly: !((profileStore.profile.hasPermission(PricingPermissions.SHARED_GRID_SETTINGS) || profileStore.profile.hasPermission(PromoPermissions.SHARED_GRID_SETTINGS_EDIT)) && profileStore.profile.id === gridSetting.userId || (profileStore.profile.hasPermission(PricingPermissions.SHARED_GRID_SETTINGS) || profileStore.profile.hasPermission(PromoPermissions.SHARED_GRID_SETTINGS_EDIT)) && gridSetting.userId === Utils.VOID_ID)
      })), React.createElement(Row, {
        between: "xs"
      }, React.createElement(Col, null, onDelete != null && (profileStore.profile.hasPermission(PricingPermissions.SHARED_GRID_SETTINGS) || profileStore.profile.hasPermission(PromoPermissions.SHARED_GRID_SETTINGS_EDIT) || profileStore.profile.id === gridSetting.userId) && React.createElement(Button, {
        type: "button",
        onClick: this.props.onDelete,
        buttonColor: ButtonColor.Outline
      }, translate('Delete'))), React.createElement(Col, null, React.createElement(Button, {
        type: "submit",
        disabled: readOnly
      }, translate('Save filter view')))))));
    }
  }]);

  return GridSettingsModal;
}(React.Component);

GridSettingsModal = __decorate([inject(function (allStores) {
  return {
    profileStore: allStores[StoreName.Profile]
  };
})], GridSettingsModal);
export default GridSettingsModal;
var StyledGridSettingsModal = styled.div(_templateObject());